export const ChatAppChatRouterParam = 'recipient-id';
export const ChatAppChatsTechnicalUserRouterQueryParam = 'technicalUserId';
